import angular from "angular";
import { moduleName as recordsModule } from "../../../records";
import { configureLookupManagement } from "../../../records/lookup/lookupManagement/config";
import {
  vsLookupManagementServiceName,
  vsLookupManagementServiceProviderName,
} from "./lookupManagement";
import { projectCostTypeConfig } from "./lookupManagement/projectCostType";
import { projectCostCategoryConfig } from "./lookupManagement/projectCostCategory";
import { projectConfig } from "./project";
import { projectMachineConfig } from "./projectMachines";
import { projectCostConfig } from "./projectCost";
export const vsModuleName = "ProjectCostSharedConfigModule";

const module = angular
  .module(vsModuleName, [recordsModule])
  .config(projectConfig)
  .config(projectMachineConfig)
  .config(projectCostTypeConfig)
  .config(projectCostCategoryConfig)
  .config(projectCostConfig);

configureLookupManagement(module, {
  baseStateSref: "main.project.lookups",
  lookupManagementServiceName: vsLookupManagementServiceName,
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  defaultModifyPermission: "projectCostLookupModify",
  entryView: "@^.^",
});
